import { render, staticRenderFns } from "./jinguojiazheng.vue?vue&type=template&id=5f811a9a&scoped=true"
import script from "./jinguojiazheng.vue?vue&type=script&lang=js"
export * from "./jinguojiazheng.vue?vue&type=script&lang=js"
import style0 from "./jinguojiazheng.vue?vue&type=style&index=0&id=5f811a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f811a9a",
  null
  
)

export default component.exports